<template>
  <el-container>
    <el-main class="reviewTaskManageMain-wrap">
      <div class="reviewTaskManageMain mt6 shadowlaw">
        <div class="filter filterReviewDetail">
          <el-form ref="form" :model="form" label-width="80px" class="clearfix">
            <el-form-item label="审查报告">
              <el-input v-model.trim="form.title__contains"></el-input>
            </el-form-item>
            <el-form-item label="审查文件">
              <el-input
                v-model.trim="form.item_uuid__checked_file_text__contains"
              ></el-input>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="form.time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <div class="operation fl operationReviewDetail">
              <a class="new f_transition" @click="searchTable">
                <i class="iconfont icon-chaxun1"></i>
                查询
              </a>
              <a class="new f_transition" @click="resetFun">
                <i class="iconfont icon-zhongzhi"></i>
                重置
              </a>
            </div>
          </el-form>
        </div>
        <div class="tableBox tableBoxReviewDetail tableBoxReviewReport">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            v-loading="loading"
          >
            <!-- <el-table-column type="selection" width="66">
						</el-table-column> -->
            <el-table-column
              prop="title"
              label="审查报告"
              min-width="40%"
              align="left"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span @click="titleFun(scope.row.id)">{{ scope.row.title }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="item_uuid__type__brief"
              label="审查类型"
              min-width="20%"
              :show-overflow-tooltip="true"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="process"
              label="审查进度"
              min-width="20%"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope"> 第{{ scope.row.process }}轮 </template>
            </el-table-column>
            <el-table-column
              prop="item_uuid__title"
              label="审查文件"
              min-width="40%"
              :show-overflow-tooltip="true"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="author_department"
              label="部门"
              min-width="20%"
              :show-overflow-tooltip="true"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="author_name"
              label="创建人"
              min-width="20%"
              :show-overflow-tooltip="true"
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="创建时间"
              min-width="20%"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">{{
                handleTime(scope.row.create_time)
              }}</template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page pt15 pb15 clearfix pageReviewDetail">
          <el-pagination
            @size-change="handleSizeChangeDeclare"
            @current-change="handleCurrentChangeDeclare"
            :current-page.sync="currentPageDeclare"
            :page-size="pageSize"
            background
            layout="total ,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
        <div class="fileBox">
          <div class="fileBoxOperation hlh50 clearfix">
            <p class="fl title por">{{ title }}</p>
            <div class="operation fr pr36 mr35 operationReviewDetail">
              <a class="new f_transition" :href="downloadUrl + report_file" v-if="title">
                <i class="iconfont icon-daochu"></i>
                导出
              </a>
              <a class="new f_transition" style="background: #ccc" v-else>
                <i class="iconfont icon-daochu"></i>导出</a
              >
              <a class="new f_transition" @click="deleteFun">
                <i class="iconfont icon-shanchu"></i>
                删除
              </a>
            </div>
          </div>
          <div class="fileBoxCon fileBoxConReviewReport">
            <happy-scroll size="3" color="#c1c4c6" :hide-horizontal="true" resize>
              <div class="con">
                <h2 class="title">{{ title }}</h2>
                <div>
                  <!-- <div v-for="(item,index) in reportData" :key="index">
										<div v-if="item.label">
											<!- 不存在_就是整篇的 ->
											<p class="paragraph" v-if="item.id.indexOf('_')<0">综合意见 （审核人：{{item.advise[0].author_name}} {{item.advise[0].create_time}}）</p>
											<p class="paragraph" v-if="item.id.indexOf('_')>0">{{item.label}} （审核人：{{item.advise[0].author_name}} {{item.advise[0].create_time}}）</p>
											<div class="advice">
												<p class="paragraph">建议{{item.advise[0].advise_type}}内容： <span>{{item.advise[0].content}}</span></p>
												<p class="paragraph">依据和理由： <span>{{item.advise[0].reason}}</span></p>
											</div>
										</div>

										<div>
											<div class="paragraph" v-for="(inside,index) in item.children" :key="index">
												<p class="paragraph">{{inside.label}} （审核人：{{inside.advise[0].author_name}} {{inside.advise[0].create_time}}）</p>
												<div class="advice">
													<p class="paragraph">建议{{inside.advise[0].advise_type}}内容： <span>{{inside.advise[0].content}}</span></p>
													<p class="paragraph">依据和理由： <span>{{inside.advise[0].reason}}</span></p>
												</div>
											</div>
										</div>
									</div> -->
                  <div v-for="(item, index) in reportData" :key="index">
                    <div v-if="item.label">
                      <div v-if="item.tag == 'total'">
                        <!-- 不存在_就是整篇的 整篇tag=total -->
                        <p class="paragraph">综合意见</p>
                        <div
                          class="advice"
                          v-for="(inside, index) in item.advise"
                          :key="index"
                        >
                          <p class="paragraph">
                            （审核人：{{ inside.author_name }} {{ inside.create_time }}）
                          </p>
                          <p class="paragraph">
                            建议<i>{{ inside.advise_type }}</i
                            >内容： <span>{{ inside.content }}</span>
                          </p>
                          <p class="paragraph">
                            依据和理由： <span>{{ inside.reason }}</span>
                          </p>
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="item.label">
                          <p class="paragraph" @click="centerCurIdFun(item)">
                            {{ item.label }}
                          </p>
                          <div
                            class="advice"
                            v-for="(insideItem, index) in item.advise"
                            :key="index"
                          >
                            <p class="paragraph">
                              （审核人：{{ insideItem.author_name }}
                              {{ insideItem.create_time }}）
                            </p>
                            <p class="paragraph">
                              建议<i>{{ insideItem.advise_type }}</i
                              >内容： <span>{{ insideItem.content }}</span>
                            </p>
                            <p class="paragraph">
                              依据和理由： <span>{{ insideItem.reason }}</span>
                            </p>
                          </div>
                        </div>
                        <div v-if="item.children && item.children.length > 0">
                          <div
                            class="paragraph"
                            @click="centerCurIdFun(inside)"
                            v-for="(inside, index) in item.children"
                            :key="index"
                          >
                            <p class="paragraph">{{ inside.label }}</p>
                            <div
                              class="advice"
                              v-for="(item2, index) in inside.advise"
                              :key="index"
                            >
                              <p class="paragraph">
                                （审核人：{{ item2.author_name }}
                                {{ item2.create_time }}）
                              </p>
                              <p class="paragraph">
                                建议<i>{{ item2.advise_type }}</i
                                >内容： <span>{{ item2.content }}</span>
                              </p>
                              <p class="paragraph">
                                依据和理由： <span>{{ item2.reason }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- item.label为空则为具体的某一条 -->
                    <div v-else>
                      <div
                        class="paragraph"
                        @click="centerCurIdFun(inside)"
                        v-for="(inside, index) in item.children"
                        :key="index"
                      >
                        <p class="paragraph">{{ inside.label }}</p>
                        <div
                          class="advice"
                          v-for="(item2, index) in inside.advise"
                          :key="index"
                        >
                          <p class="paragraph">
                            （审核人：{{ item2.author_name }} {{ item2.create_time }}）
                          </p>
                          <p class="paragraph">
                            建议<i>{{ item2.advise_type }}</i
                            >内容： <span>{{ item2.content }}</span>
                          </p>
                          <p class="paragraph">
                            依据和理由： <span>{{ item2.reason }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                　　 　　
              </div>
            </happy-scroll>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      //筛选条件start==
      form: {
        title__contains: "", //标题
        item_uuid__checked_file_text__contains: "", //审查文件
        time: [], //时间
      },
      //筛选条件end==

      //表格start==
      loading: false, //加载中
      tableData: [],
      multipleSelection: [], //表格选中数据
      //表格end==

      //分页start==
      currentPageDeclare: 1, //当前页
      total: 0, // 总共条数
      pageSize: 5, //每页的数量
      //分页end==

      title: "", //报告标题
      reportData: [], //报告数据
      report_id: Number, //报告id
      report_file: "", //生成报告文件路径
      downloadUrl: this.url.downloadUrl, //头像链接公共部分
      taskUuid: "", //任务的uuid
    };
  },
  created() {
    this.report_id = parseInt(window.localStorage.getItem("report_id"));

    //从审查报告跳转过来需要先通过报告id获取对应任务的uuid
    if (window.localStorage.getItem("reviewStage") == "task") {
      this.axios
        .get("/japi/check/get_task_by_report_id/?report_id=" + this.report_id)
        .then((res) => {
          console.log("获取任务的uuid======");
          console.log(res);
          if (res.data.code == 200) {
            window.localStorage.setItem("taskUuid", res.data.data); //任务的uuid
            this.taskUuid = window.localStorage.getItem("taskUuid"); //任务的uuid
            this.tableFun(1); //表格数据
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
    } else {
      this.taskUuid = window.localStorage.getItem("taskUuid"); //任务的uuid
      this.tableFun(1); //表格数据
    }
    this.getReportDataFun(this.report_id); //查看报告数据
  },
  methods: {
    //分页
    handleSizeChangeDeclare(size) {
      // console.log(`每页 ${size} 条`);
      this.pageSize = size;
      this.tableFun(this.currentPageDeclare);
    },
    handleCurrentChangeDeclare(currentPage) {
      // console.log(`当前页: ${currentPage}`);
      this.currentPageDeclare = currentPage;
      this.tableFun(this.currentPageDeclare);
    },
    //将时间中的T换成空格
    handleTime(t) {
      t = t.replace(new RegExp(/(T)/g), "\u00a0");
      return t;
    },
    //重置
    resetFun() {
      this.form.title__contains = ""; //审查报告
      this.form.item_uuid__checked_file_text__contains = ""; //审查文件 原文
      this.form.time = []; //时间
      this.currentPageDeclare = 1;
      this.tableFun(1);
    },
    //域内检索
    searchTable() {
      this.currentPageDeclare = 1;
      this.tableFun(1);
    },
    //获取table中的数据 uuid为任务的uuid
    tableFun(str) {
      this.loading = true; //加载中显示
      let startTime = "";
      let endTime = "";
      if (this.form.time && this.form.time.length > 0) {
        startTime = this.form.time[0];
        endTime = this.form.time[1];
      } else {
        startTime = "";
        endTime = "";
      }
      this.axios
        .get(
          "/japi/check/report_handle/?tag=task&page=" +
            str +
            "&page_num=" +
            this.pageSize +
            "&uuid=" +
            this.taskUuid +
            "&item_uuid__checked_file_text__contains=" +
            this.form.item_uuid__checked_file_text__contains +
            "&title__contains=" +
            this.form.title__contains +
            "&create_time__gte=" +
            startTime +
            "&create_time__lte=" +
            endTime
        )
        .then((res) => {
          if (res.data.code == 200) {
            console.log("审查报告表格数据======");
            console.log(res);
            this.total = res.data.data.sum;
            this.tableData = res.data.data.res;
            this.loading = false; //加载中隐藏
          } else if (res.data.code == 500) {
            this.loading = false;
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
    },

    //删除
    deleteFun() {
      this.$confirm("请确认是否删除当前查看的备案审查报告数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false, //是否可通过点击遮罩关闭MessageBox
      })
        .then(() => {
          //确定
          this.axios({
            method: "delete",
            url: "/japi/check/report_handle/",
            data: {
              id: this.report_id,
            },
          }).then((res) => {
            if (res.data.code == 200) {
              console.log("删除报告成功======");
              console.log(res);
              this.$message({
                message: "删除报告成功",
                type: "success",
                duration: 3000,
              });
              this.$router.push("/refresh");
              //此处需要先将删除元素从表格数据中移出 获取第一条数据的id进行数据请求
              this.tableData.forEach((item, index) => {
                if (item.id == this.report_id) {
                  this.tableData.splice(index, 1);
                }
              });
              this.report_id = this.tableData[0].id;
              this.tableFun(this.currentPageDeclare); //获取数据
              this.getReportDataFun(this.tableData[0].id); //查看报告详情 -删除之后展示第一条数据的详情
            } else if (res.data.code == 500) {
              this.$message({
                message: res.data.msg,
                type: "warning",
                duration: 3000,
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning",
                duration: 3000,
              });
            }
          });
        })
        .catch(() => {
          //不加catch会报错
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //查看报告数据
    getReportDataFun(report_id) {
      this.axios
        .get("/japi/check/report_handle/?tag=detail&uuid=" + report_id)
        .then((res) => {
          if (res.data.code == 200) {
            console.log("查看报告成功======");
            console.log(res);
            if (res.data.data[0]) {
              this.title = res.data.data[0].title;
              this.reportData = res.data.data[0].content;
              this.report_file = res.data.data[0].report_file; //生成报告 文件路径
            }
          } else if (res.data.code == 500) {
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
    },
    //点击标题 下方切换报告数据详情
    titleFun(id) {
      this.report_id = id;
      this.getReportDataFun(id); //查看报告详情
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/mixin.scss"; //定义方法
@import "../../../../assets/css/recordReviewDetail.scss"; //备案审查详情页样式
</style>
